<template>
<div class="verAddCon"  v-if='showModel'>
        <div class="title">{{title}}</div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" inline>

           <!-- 基础型号id -->
             <FormItem :label="$t('BasicProduct.titleName.Id')"  class="ivu-form-item-required"  style="width: 560px" v-if='type==2'>
                <Input type="text"  :value="formData.id" disabled ></Input>
            </FormItem>

            <!-- 基础型号名称 -->
             <FormItem :label="$t('BasicProduct.titleName.basicName')" prop="basicName" style="width: 560px">
                <Input type="text" maxlength="60" v-model.trim="formData.basicName" :placeholder="$t('ruleCustom.basicName')"  ></Input>
            </FormItem>


            <!-- 产品名称 -->
             <FormItem :label="$t('BasicProduct.titleName.baseNick')" prop="baseNick" style="width: 560px">
                <Input type="text" maxlength="500" v-model.trim="formData.baseNick" :placeholder="$t('inputPlaceholder')"  ></Input>
            </FormItem>

             <!-- 页面编号 -->
             <FormItem :label="$t('BasicProduct.titleName.pageId')" class="ivu-form-item-required" prop="pageId"  style="width: 560px;">
                <SearchSelectRecycle refName="pageIdRef" :showPage="true" ref="pageIdRef" :selectUrlQuery="{}" :url="pagesIdListUrl" labelName='pageId'  isMultiple='2'  valName='pageId' labelNameNew="description"  keyword="pageId" :labelInValue="true" :placeholderText="type==1?$t('selectPlaceholder'):$t('selectloadingPlaceholder')"  @setSelected="setSelectValNew($event,'pageId')"></SearchSelectRecycle>
            
            </FormItem>

            <!-- 基础分类 -->
             <FormItem :label="$t('BasicProduct.titleName.basicClassId')" class="ivu-form-item-required" prop="basicClassIdArr"  style="width: 560px">
                <div class="flexBC">
                    <div class="flex-grow-1">
                        <Cascader :data="basicClassDataList" v-model="formData.basicClassIdArr" change-on-select @on-change='changeBasicClass'></Cascader>
                    </div>
                    <div class="flex-shrink-0 editText" @click="showBasicClass">{{$t('BasicProduct.basicClassBox.edit')}}</div>
                </div>
            </FormItem>

            
            <!-- 实现类型 -->
            <FormItem :label="$t('BasicProduct.titleName.designImplType')" class="ivu-form-item-required" prop="designImplType"  style="width: 560px">
                 <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.designImplType" @on-select="designImplTypeSelect">
                     <Option v-for="(item, index) in selectObj.designImplTypeList" :value="item.id" :key="index">{{item['val']}}</Option>
                 </Select>
            </FormItem>

            <!-- 通信方式 -->
            <FormItem :label="$t('BasicProduct.titleName.comType')" class="ivu-form-item-required divinput" prop="comType" style="width: 560px">
                <div  :class="['ivu-input', 'one-txt-cut', 'ivu-input-div',comTypeRequired?'redBorder':'']"   @click="editComParadigm">
                  <div v-if="comTypeText" :title="comTypeText">{{comTypeText}}</div>
                  <div v-else style="color:#c5c8ce">{{$t("selectPlaceholder")}}</div>
                </div>
                <div v-if="comTypeRequired" class="ivu-form-item-error-tip">{{$t('required')}}</div>
            </FormItem>

            <!-- 通信类别，上线后会删掉 -->
            <FormItem :label="$t('BasicProduct.titleName.comMode')" class="ivu-form-item-required" prop="comMode"  style="width: 560px">
                 <!-- <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.comMode"  :disabled="formData.communicateProtocol == 3"> -->
                 <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.comMode" >
                     <Option v-for="(item, index) in selectObj.comModeList" :value="item.id" :key="index">{{item['val']}}</Option>
                 </Select>
            </FormItem>

            <!-- 功能类别 -->
             <FormItem  v-if='formData.designImplType==1 || formData.designImplType==5' :label="$t('BasicProduct.titleName.smDeviceType')" class="ivu-form-item-required" prop="smDeviceType"  style="width: 560px">
                 <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.smDeviceType" >
                     <Option v-for="(item, index) in selectObj.smDeviceTypeList" :value="item.id" :key="index">{{item['val']}}</Option>
                 </Select>
            </FormItem>

            <!-- 通道数 -->
             <FormItem v-if='formData.designImplType==1 || formData.designImplType==5' :label="$t('BasicProduct.titleName.channelNumber')" class="ivu-form-item-required" prop="channelNumber" style="width: 560px">
                <InputNumber  v-model.trim="formData.channelNumber" :min="1" :precision='0' :placeholder="$t('inputPlaceholder')" ></InputNumber >
            </FormItem>
           
            <!-- 联网方式 -->
            <FormItem :label="$t('BasicProduct.titleName.connectMode')" class="ivu-form-item-required" prop="connectMode"  style="width: 560px">
                 <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.connectMode" >
                     <Option v-for="(item, index) in selectObj.connectModeList" :value="item.id" :key="index">{{item['val']}}</Option>
                 </Select>
            </FormItem>


            <!-- 应用协议 -->
            <FormItem :label="$t('BasicProduct.titleName.communicateProtocol')" class="ivu-form-item-required" prop="communicateProtocol"  style="width: 560px">
                 <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.communicateProtocol">
                     <Option v-for="(item, index) in selectObj.communicateProtocolList" :value="item.id" :key="index">{{item['val']}}</Option>
                 </Select>
             </FormItem>
            
            <!-- lora二进制实现方式 或 通信方式上下行里有LoRaWan|| comTypeText.includes('LoRaWan') -->
            <!-- <FormItem v-if="formData.communicateProtocol ==1 " :label="$t('BasicProduct.titleName.loraProductKey')" class="ivu-form-item-required" prop="loraProductKey"  style="width: 560px">
                <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.loraProductKey" >
                     <Option v-for="(item, index) in selectObj.loraProductKeyList" :value="item.id" :key="index">{{item['val']}}</Option>
                 </Select>
            </FormItem> -->
            
            <!-- 对接产品  hyecosmart这种的指令实现方式 -->
            <FormItem v-if="formData.communicateProtocol ==3" :label="$t('BasicProduct.titleName.loraProductKeyOne')" class="ivu-form-item-required" prop="loraProductKey"  style="width: 560px">
                <SearchSelectRecycle refName="loraProductKeyRef" :showPage="true" ref="loraProductKeyRef" :selectUrlQuery="{}" :url="getProductListFromHyeco" labelName='loraProductKey'  isMultiple='2'  valName='loraProductKey' labelNameNew="basicName"  keyword="loraProductKey" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValNew($event,'loraProductKey')"></SearchSelectRecycle>
            </FormItem>

            <!-- 子设备类型 -->
            <!-- hyecosmart这种的指令实现方式，且connectMode是3 网关下设备 -->
            <!-- 实现类型是二进制klv，且connectMode是6 基站下设备 formData.designImplType ==2 && formData.connectMode ==6   240703,改成了只要选择基站下设备，就有子设备类型 -->
            <FormItem v-if="(formData.designImplType ==3 && formData.connectMode ==3)" :label="$t('BasicProduct.titleName.subdeviceType')" class="ivu-form-item-required" prop="subdeviceType"  style="width: 560px">
                 <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.subdeviceType">
                     <Option v-for="(item, index) in selectObj.subdeviceTypeList" :value="item.id" :key="index">{{item['val']}}</Option>
                 </Select>
            </FormItem>

            <FormItem v-if="(formData.connectMode ==6)" :label="$t('BasicProduct.titleName.subdeviceType')" class="ivu-form-item-required" prop="subdeviceType"  style="width: 560px">
                 <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.subdeviceType">
                     <Option v-for="(item, index) in selectObj.subdeviceTypeLoraList" :value="item.id" :key="index">{{item['val']}}</Option>
                 </Select>
            </FormItem>

            <!-- 场景互动 -->
             <FormItem :label="$t('BasicProduct.titleName.joinSense')" class="ivu-form-item-required" prop="joinSense1"  style="width: 560px">
                 <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.joinSense1" >
                     <Option v-for="(item, index) in selectObj.joinSenseList" :value="item.id" :key="index">{{item['val']}}</Option>
                 </Select>
            </FormItem>

            <!-- 经销商 -->
             <FormItem :label="$t('deviceManage.dealerModel.Dealer')" prop="customerId"  style="width: 560px" class="ivu-form-item-required">
                <SearchSelectRecycle refName="customerIdRef" listName="dealersList"  :showPage="true" ref="customerIdRef" :selectUrlQuery="{page:1,limit:10000}" :url="userUrl" labelName='companyName'  isMultiple='2'  valName='id' labelNameNew="description"  keyword="companyName" :labelInValue="true" :placeholderText="type==1?$t('selectPlaceholder'):$t('selectloadingPlaceholder')"  @setSelected="setSelectValNew($event,'customerId')"></SearchSelectRecycle>
            
            </FormItem>

            <!-- MAC数量 -->
             <FormItem :label="$t('BasicProduct.titleName.macQty')" prop="macQty" style="width: 560px">
                <InputNumber  v-model.trim="formData.macQty" :min="0" :precision='0' :placeholder="$t('inputPlaceholder')" ></InputNumber >
            </FormItem>
            
            <!-- 是否分享 -->
             <FormItem :label="$t('BasicProduct.titleName.whetherShare')" prop="whetherShare" style="width: 560px">
                <Select :placeholder="$t('selectPlaceholder')"  clearable class="input-div" v-model="formData.whetherShare">
                    <Option v-for="item in selectObj.requiredList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                </Select>
            </FormItem>
            
            <!-- 离线更改 -->
            <FormItem :label="$t('BasicProduct.funcBox.titleName.UpdateAsOffline')" prop="offlineOperation" style="width: 560px">
                <Select :placeholder="$t('selectPlaceholder')"  clearable class="input-div" v-model="formData.offlineOperation">
                    <Option v-for="item in selectObj.requiredList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                </Select>
            </FormItem>

            <!-- 主功能键 -->
             <FormItem v-if='type==2' :label="$t('BasicProduct.titleName.majorKey')" prop="majorKeyId"  style="width: 560px" class="">
                <SearchSelectMajor ref="majorKeyRef" :selectUrlQuery="{'serachMajorKey':true,basicTypeId:editFormData.id||null}" :hasDealerId="false"  :url="getBasicKeysUrl"  labelName='keyNameZH' isMultiple='2'  valName='id' keyword="keyNameZH" :labelInValue="true" :placeholderText="type==1 || (type==2 && (!editFormData.majorKeyId  || !formData.majorKeyId))?$t('selectPlaceholder'):$t('selectloadingPlaceholder')"   @setSelected="setSelectVal($event,'majorKeyId')"></SearchSelectMajor>
            </FormItem>

    
           <!-- 备注 -->
            <FormItem :label="$t('BasicProduct.titleName.remark')" prop="remark" style="width: 560px">
                <Input type="textarea" maxlength="100"  show-word-limit v-model.trim="formData.remark"  :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

          <!-- 图片 -->
            <FormItem :label="$t('BasicProduct.titleName.imageId')" prop="imageId" class="logoCon ivu-form-item-required" style="min-width: 560px;display: flex;align-items: center;">
                <ImgUpload style="margin-top: 20px" ref="upLogoImg" :action="uploadUsersAvatar" :hasUpload="hasUpload" compressImageSize="300,120" :num="1" @setThumbUrl="setThumbUrlthumb" @removeThumbUrl='removeThumbUrl'></ImgUpload>
                <span class="simple-size">500x500dpi</span>
            </FormItem>
            
            <!--  -->
            <div v-if='type==2' class="changeBox">
                <!-- <Checkbox v-model="formData.modifyModelSync" style="display: block;margin: 0px 0px 10px 162px">{{$t('BasicProduct.titleName.modifyModelSync')}}</Checkbox>
                <Checkbox v-model="formData.modifyDeviceSync" style="display: block;margin: 0px 0px 10px 162px">{{$t('BasicProduct.titleName.modifyDeviceSync')}}</Checkbox> -->
                <Checkbox v-model="formData.forbidden" style="display: block;margin: 0px 0px 10px 162px">{{$t('BasicProduct.titleName.deactivateModelSync')}}</Checkbox>
            </div>

            <div style="margin: 30px 0px 10px 162px">
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </div>
          
        </Form>

         <!-- 管理员密码 -->
        <AdminModel ref='verifyPwdRef' :showSetModel.sync="adminModelBox.showModel" :editFormData="adminModelBox.editFormData" :fn="adminModelBox.callbackFn" :loading="adminModelBox.loading"></AdminModel>
        
        <!-- 上下行参数 -->
        <ComParadigmModel  :showModel.sync="comTypeBox.showModel" :editFormData="comTypeBox.editFormData" :fn="comTypeBox.callbackFn" ></ComParadigmModel>

        <!-- 基础分类 -->
        <BasicClassModel :showModel.sync="basicClassBox.showModel" :editFormData="basicClassBox.editFormData" :fn="basicClassBox.callbackFn" ></BasicClassModel>

         
</div>

</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import ImgUpload from "@/views/common/upload";
import { mapState } from 'vuex'
import SearchSelect from '../../common/selectList.vue';  //20220415
import SearchSelectMajor from './selectList.vue';  //20220415
import SearchSelectRecycle from '@/views/common/selectListRecycle.vue';  //20220415

import AdminModel from './componentOther/showAdminModel.vue';  
import ComParadigmModel from './componentOther/comTypeModel.vue';  
import BasicClassModel from './componentOther/basicClassModel.vue';  
import {toTree} from "@/libs/tools.js"


    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            // basicClassIdList:Array,
            // basicClassIdList1:Array
        },
        name: "Model3",
        components: {
            ImgUpload,
            SearchSelect,
            SearchSelectRecycle,
            SearchSelectMajor,
            AdminModel,
            ComParadigmModel,
            BasicClassModel
        },
        data() {
            return {   
                pagesIdListUrl: this.config.urlArray.pagesIdList,//页面编号
                uploadUsersAvatar:this.config.urlArray.uploadImg, //上传图片接口
                userUrl: this.config.urlArray.dealerpageList,//经销商列表
                getBasicKeysUrl:this.config.urlArray.getBasicKeys,//获取一个基础型号对应的键，或者的所有键
                getProductListFromHyeco:this.config.urlArray.getProductListFromHyeco,//获取hyeco平台的设备列表
                hasUpload: [], //已上传图片
                disabled: false,//禁用确定按钮
                // title: '',//弹框标题
                formData: {//表单数据
                    basicName:"",//基础型号的名称
                    baseNick:"",//产品名称
                    basicClassId:"",//基础分类编号
                    basicClassIdArr: [],//
                    comMode:"",//通信类别：1-蓝牙，2-wifi，3-loraDTU，4-loraWan，5-蓝牙mesh,6-蓝牙5.0
                    comType:"",//通信方式 [{'up':''},{'down':''}]
                    connectMode:"",//连网方式：1-不联网，2-网关，3-网关下设备，4-直连设备
                    pageId:'',//页面模型编号
                    smDeviceType:"",//设备类型，设备是主设备还是辅助设备，1-主设备，2-辅助设备雨量计，3-辅助设备阀门流量计，4-辅助设备土壤干湿计
                    macQty:null,//mac地址的数量，有的蓝牙产品
                    loraProductKey:"",//对应的是loraServer那边的productKey.目前有四种，classA,classB,classC,网关
                    // frequency:"",//频段，这产品使用的频段
                    channelNumber:null,//阀门数量
                    imageId:'',//基础型号对应的上传的图片编号
                    designImplType:'',//设计实现类型,1-蓝牙和早前的WiFi的设计实现方式，2代表lora设备产品的这种实现方式,3吕伟平台json，4直连aqube平台就能使用
                    joinSense:"",//是否参与场景互动（lora的设备），默认true-参与场景互动
                    joinSense1:"",
                    remark:'',//备注
                    published:false,//是否已经发布,211026新增
                    customerId:"",//服务的经销商编号,211026新增
                    whetherShare:"",//不开放分享为此商家私有开发产品，其它商家不能选择此基础型号,211026新增
                    communicateProtocol:"",//通讯协议的类型,1-lora产品的二进制协议，2-私有协议，类似蓝牙产品的这种协议，3-吕伟平台json,211026新增,4-其他
                    offlineOperation:"",
                    majorKeyId:'',//主功能键    下拉选    显示功能名称，保存功能键编号
                    // modifyModelSync:false,
                    // modifyDeviceSync:false,
                    forbidden:false,//是否是禁用了的，true-禁用，false-非禁用），创建基础型号的时候不用送，修改基础型号的时候带过来
                    subdeviceType:"",//hyecosmart平台,communicateProtocol是3，并且connectMode是3的时候，需要展示subdeviceType
                },
                photoArr:[],
                adminModelBox:{
                    showModel:false,
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                    loading:false
                },
                comTypeBox:{
                    showModel:false,
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                basicClassBox:{
                    showModel:false,
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                comTypeText:"",
                comTypeRequired:false,
                productListFromHyeco:[],
                basicClassDataList:[],
                basicClassIdList:[],
                basicClassIdList1:[]
            }
        },
       
        computed:{
             ...mapState(['local','selectId']),
             title(){
                let title = this.type == 1?this.$t('BasicProduct.addBox.title'):this.$t('BasicProduct.addBox.title1')
                return title
             },
            ruleCustom(){
                return {
                    basicName: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {pattern: /^[a-zA-Z0-9_\-\s]*$/, message: this.$t('ruleCustom.basicName'), trigger:'blur'}
                    ],
                    description: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    comMode: [
                        {type: 'number',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    connectMode: [
                        {type: 'number',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    subdeviceType: [
                        {type: 'number',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    designImplType: [
                        {type: 'number',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    smDeviceType: [
                        {type: 'number',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    loraProductKey: [
                        {type: 'string',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    joinSense1: [
                        {type: 'string',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    // joinSense: [
                    //     {type: 'number',required: true, message: this.$t('required'),trigger: 'change' },
                    // ],
                    whetherShare: [
                        {type: 'string',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    offlineOperation: [
                        {type: 'string',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    communicateProtocol: [
                        {type: 'number',required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    basicClassIdArr: [
                        {type: 'array',required: true, message: this.$t('required'),trigger: 'change' },
                        {type: 'array',required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    channelNumber: [
                        { validator: this.validateChannelNumber,trigger: 'blur' }
                    ],
                    // frequency: [
                    //     { validator: this.validateFrequency,trigger: 'change' }
                    // ],
                    pageId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    imageId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    customerId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    basicClassId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    macQty: [
                        {required: true, message: this.$t('required'),trigger: 'blur',type:'number' },
                    ]
                }
            },
            selectObj(){
                return {
                    connectModeList:[
                        {id: 1,val:this.$t('selectList.connectListBasic.Not_networked')},//不联网
                        {id: 2,val:this.$t('selectList.connectListBasic.Gateway')},//网关
                        {id: 3,val:this.$t('selectList.connectListBasic.Gateway_device')},//网关下设备
                        {id: 4,val:this.$t('selectList.connectListBasic.direct-connected_facility')},//直连设备
                        {id: 5,val:this.$t('selectList.connectListBasic.base_station')},//基站
                        {id: 6,val:this.$t('selectList.connectListBasic.base_station_facility')},//基站下设备
                    ],
                    comModeList:[
                        {id: 2,val:this.$t('selectList.comModeListBasic.WIFI')},
                        {id: 1,val:this.$t('selectList.comModeListBasic.BLE')},
                        {id: 6,val:this.$t('selectList.comModeListBasic.BLE5')},
                        {id: 5,val:this.$t('selectList.comModeListBasic.BLEMesh')},
                        {id: 3,val:this.$t('selectList.comModeListBasic.LORADTU')},
                        {id: 4,val:this.$t('selectList.comModeListBasic.LORAWan')},
                        {id: 7,val:this.$t('selectList.comModeListBasic.4GCat1')},
                        {id: 8,val:this.$t('selectList.comModeListBasic.RS485')},
                        // {id: 9,val:this.$t('selectList.comModeListBasic.4G')},
                        {id: 30,val:this.$t('selectList.comModeListBasic.other')},
                    ],
                    smDeviceTypeList:[
                        {id: 1,val:this.$t('selectList.smDeviceTypeBasic.Main_equipment')},
                        {id: 2,val:this.$t('selectList.smDeviceTypeBasic.Rain_gauge')},
                        {id: 3,val:this.$t('selectList.smDeviceTypeBasic.Valve_flowmeter')},
                        {id: 4,val:this.$t('selectList.smDeviceTypeBasic.Soil_hygrometer')},
                    ],
                   loraProductKeyList:[//如果是designImplType为2，那loraProductKey就是以前固定的那个classABC网关这四个值，供用户选择
                        {id: 'A6k_t3Rng',val:this.$t('selectList.loraProductKeyBasic.A6k_t3Rng')},//LoRaWan classA
                        {id: 'u_ElpqR7R',val:this.$t('selectList.loraProductKeyBasic.u_ElpqR7R')},//LoRaWan classB
                        {id: 'HJTutqgnR',val:this.$t('selectList.loraProductKeyBasic.HJTutqgnR')},//LoRaWan classC
                        {id: 'aYFrpqg7g',val:this.$t('selectList.loraProductKeyBasic.aYFrpqg7g')},//LoRaWan 网关
                        // {id: 'None',val:'None'},
                    ],
                    joinSenseList:[
                        {id:'true',val:this.$t('selectList.joinSenseList.true')},
                        {id:'false',val:this.$t('selectList.joinSenseList.false')},
                        // {id:1,val:this.$t('selectList.joinSenseList.type1')},
                        // {id:2,val:this.$t('selectList.joinSenseList.type2')},
                        // {id:3,val:this.$t('selectList.joinSenseList.type3')},
                        // {id:4,val:this.$t('selectList.joinSenseList.type4')},
                    ],
                    requiredList:[
                        {id: 1,val:this.$t('selectList.MustedList.true')},
                        {id: 2,val:this.$t('selectList.MustedList.false')},
                    ],
                    designImplTypeList:[//1,以前的蓝牙和部分wifi的实现方式  2,"LORA的实现方式的产品，主要用key定义的模式的  3,hyecosmart的指令实现方式,4,直连aqube平台就能使用的;5，"以前的wiFi产品的实现方式"
                        {id: 1,val:this.$t('selectList.designImplTypeList.type1')},
                        {id: 2,val:this.$t('selectList.designImplTypeList.type2')},
                        {id: 3,val:this.$t('selectList.designImplTypeList.type3')},
                        {id: 4,val:this.$t('selectList.designImplTypeList.type4')},
                        {id: 5,val:this.$t('selectList.designImplTypeList.type5')},
                    ], 
                    subdeviceTypeList:[
                        {id: 1,val:this.$t('selectList.subdeviceTypeList.LORAWAN_A')},//LoRaWan子设备
                        {id: 5,val:this.$t('selectList.subdeviceTypeList.LORAWAN_B')},//LoRaWan子设备
                        {id: 6,val:this.$t('selectList.subdeviceTypeList.LORAWAN_C')},//LoRaWan子设备
                        {id: 2,val:this.$t('selectList.subdeviceTypeList.LORADTU')},//LoRaDTU子设备
                        {id: 3,val:this.$t('selectList.subdeviceTypeList.MODBUS')},//通用485子设备
                        {id: 4,val:this.$t('selectList.subdeviceTypeList.HYBUS')},//私有485子设备
                    ],
                    subdeviceTypeLoraList:[
                        {id: 1,val:this.$t('selectList.subdeviceTypeList.LORAWAN_A')},//LoRaWan子设备
                        {id: 5,val:this.$t('selectList.subdeviceTypeList.LORAWAN_B')},//LoRaWan子设备
                        {id: 6,val:this.$t('selectList.subdeviceTypeList.LORAWAN_C')},//LoRaWan子设备
                    ],
                    communicateProtocolList:[//1,"lora产,2，蓝牙,3，"hyecosmart的json协议,4,"其他协议
                       {id: 1,val:this.$t('selectList.communicateProtocolList.type1')},
                       {id: 2,val:this.$t('selectList.communicateProtocolList.type2')},
                    //    {id: 3,val:this.$t('selectList.communicateProtocolList.type3')},
                       {id: 3,val:this.$t('selectList.communicateProtocolList.type5')},
                       {id: 4,val:this.$t('selectList.communicateProtocolList.type4')},
                    ],
                    interactionChannelList:[
                        {id: 1,val:'Direct'},
                        {id: 2,val:'LoRaLiteServer'},
                        {id: 3,val:'HyecoCloud'},
                        {id: 4,val:'Gateway'},
                        {id: 5,val:'None'},
                    ]
                    // frequencyList:[
                    //    {id: "433",val:433},
                    //    {id: "470",val:470},
                    //    {id: "868",val:868},
                    //    {id: "915",val:915},
                    // ]
 
                }
            },

        },
        created(){
           
        },
        mounted(){
        },
        watch:{
            async showModel(val){
                if(val === true) {   
                    await this.getCate()
                   
                   
                    this.$nextTick(()=>{//select赋值
                        // this.$refs.pageId.setQuery(null)
                        // this.$refs.customerIdRef.setQuery(null)
                        if(this.type==2){

                            this.$refs.majorKeyRef.setQuery(null)
                        }
                    }); 
                   
                    console.log(this.editFormData)
                    console.log('type',this.type)
                    


                    if(this.type == 1){
                      this.$refs.pageIdRef.getData()
                      this.$refs.customerIdRef.getData()
                    }

                    if(this.type==2){

                        for (let key in this.editFormData) {
                            if (this.formData.hasOwnProperty(key)) {
                                this.formData[key] = this.editFormData[key]
                            }
                        }
                        this.formData.id = this.editFormData.id
                        this.formData.pageId = this.editFormData.pageId+ ''
                        this.formData.customerId = this.editFormData.customerId+ ''
                        this.formData.majorKeyId = this.editFormData.majorKeyId?this.editFormData.majorKeyId+ '':''
                        this.formData.joinSense1= this.editFormData.joinSense+""
                        this.formData.whetherShare= this.editFormData.whetherShare?'1':'2'
                        this.formData.offlineOperation= this.editFormData.offlineOperation?'1':'2'

                        if(this.formData.designImplType ==2){

                            if(this.formData.connectMode ==6){//且connectMode是6 基站下设备
                                let obj = {'1':'A6k_t3Rng','5':'u_ElpqR7R','6':'HJTutqgnR'}
                                this.formData.loraProductKey = obj[this.formData.subdeviceType]
                            }else if(this.formData.connectMode ==5){//且connectMode是5 基站
                                this.formData.loraProductKey = 'aYFrpqg7g'
                            }
                        }

                        try {
                            let comTypeTextObj = JSON.parse(this.formData.comType)
                            this.comTypeText = `↑:${comTypeTextObj[0]["UP"]}/↓:${comTypeTextObj[1]["DOWN"]}`
                        } catch (error) {
                            
                        }
                        
            
                        let flag = this.getALLId(this.formData.basicClassId)
                        this.formData.basicClassIdArr = flag || []
                   
                        // this.photoArr = [this.editFormData.imageId]
                        this.photoArr = this.editFormData.imageId.split(',')
                  
                        this.$nextTick(()=>{//select、图片赋值
                            // this.$refs.pageId.setDefVal(Number(this.formData.pageId));
                            // this.$refs.customerIdRef.setDefVal(Number(this.formData.customerId))
                            this.$refs.majorKeyRef.setDefVal(Number(this.formData.majorKeyId))
                            // let hasUpload = [{status:'finished', response:{data:this.editFormData.imageId}}]
                            let hasUpload = [{status:'finished', response:{data:this.photoArr[0]}}]
                            this.$refs.upLogoImg.setHasUpload(hasUpload)
                        }); 


                        try {
                            this.$refs.pageIdRef.setDefVal({
                                pageId:this.formData.pageId*1,
                            })

                            this.$refs.customerIdRef.setDefVal({
                                id:this.formData.customerId*1,
                            })
                         
                            if(this.formData.communicateProtocol ==3){
                                this.$nextTick(()=>{
                                    this.$refs.loraProductKeyRef.setDefVal({
                                        loraProductKey:this.formData.loraProductKey,
                                    })
                                })
                            }
                        } catch (error) {
                            this.$refs.pageIdRef.clearVal()
                            this.$refs.customerIdRef.clearVal()
                            console.log('error',error)
                            if(this.formData.communicateProtocol ==3){
                                this.$nextTick(()=>{
                                    this.$refs.loraProductKeyRef.clearVal()
                                })
                            }
                        }
                    }

                  
                  
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                    // this.$refs.pageId.clearVal();
                    // this.$refs.customerIdRef.clearVal();
                    if(this.type==2){
                        this.$refs.majorKeyRef.clearVal();
                    }
                    this.$refs.upLogoImg.clearImg()



                    this.$refs.pageIdRef.clearVal()
                    this.$refs.customerIdRef.clearVal()

                    if(this.formData.communicateProtocol ==3){
                        this.$nextTick(()=>{
                            this.$refs.loraProductKeyRef.clearVal()
                        })
                    }
                }
            },
            'formData.communicateProtocol':{
                handler: function (newValue, oldValue) {
                    if(newValue==3){
                        this.$nextTick(() => {
                            this.$refs.loraProductKeyRef.getData()
                        })

                    }
                //     if(newValue==3 && this.productListFromHyeco.length==0){
                //      this.axios.post(this.config.urlArray.getProductListFromHyeco,{}).then(res=>{
                //         console.log('res',res)
                //         if(res.data.code==1){
                //             this.productListFromHyeco = res.data.data
                //         }
                //       })
                //    }
                },
                deep: true
            }
        },
        methods: {
            async getCate(){//获取全部分类数据
                 let res = await this.axios.post(this.config.urlArray.typeCateList, {parentClassId:null})

                 common.ajaxMsg(res.data,false,()=>{
                    this.basicClassIdList1 = res.data.data
                    this.basicClassIdList = toTree(this.basicClassIdList1)
                    this.basicClassDataList =common.deepClone(this.basicClassIdList) 
                 },()=>{

                 })
                 
            },
            editComParadigm(){//编辑通信方式
                
                this.comTypeBox.showModel = true

                if(this.formData.comType){
                    let comTypeObj = JSON.parse(this.formData.comType)
                    this.comTypeBox.editFormData = {
                        "UP":(comTypeObj[0]["UP"]).split(";"),
                        "DOWN":(comTypeObj[1]["DOWN"]).split(";")
                    }
                }

                console.log('this.comTypeBox.editFormData',this.comTypeBox.editFormData)
                this.comTypeBox.callbackFn = (obj)=>{
                    
                    this.comTypeBox.showModel = false

                    this.formData.comType = JSON.stringify([
                        {
                            "UP":obj.up.join(';')
                        },
                        {
                            "DOWN":obj.down.join(';')
                        }
                    ])
                    
                    this.comTypeText = `↑:${obj.up.join(';')}/↓:${obj.down.join(';')}`
                   
                    this.comTypeRequired = false
                }
            },
            showBasicClass(){//编辑基础分类
                this.basicClassBox.showModel = true
                this.basicClassBox.editFormData = this.basicClassIdList1
                this.basicClassBox.callbackFn = (obj)=>{
                    this.basicClassBox.showModel = false
                    this.getCate()
                    this.formData.basicClassIdArr = []
                }
            },
            validateChannelNumber(rule, value, callback){ //如果为主设备，channelNumber必填,//非零的正整数
    
                if(this.formData.designImplType==1){
                    //  console.log('value',value)
                     if(value===null){
                         callback(new Error(this.$t('ruleCustom.positive_integer')));
                     }

                    callback();

                }else{
                    callback();
                }

            },
            validateFrequency(rule, value, callback){ //设计类型字段designImplType是lora型(值为2)的会有loraProductKey     frequency     joinSense字段必送。如果是蓝牙和以前的wifi类型的smDeviceType字段必送。这两个是两条路线。
        
                if(this.formData.designImplType==2){
                   
                    if(value===''){
                        callback(new Error(this.$t('required')));
                    }else{

                        callback();
                    }


                }else{
                    callback();
                }

            },
            
            getALLId(flagId){
              let aaid = flagId
              let list = this.basicClassIdList1
              let res = []
              while (aaid) {
                for(let i=0;i<list.length;i++){
                  if(list[i].id == aaid){
                    if(list[i].parentClassId){
                      res.unshift(list[i].parentClassId)
                      aaid = list[i].parentClassId
                      break
                    }else{
                      res.push(flagId)
                      return res
                    }
                  }
                }
                
              }
            },
            changeBasicClass(e,item){
                this.formData.basicClassId = e[e.length-1]

            },
            changeBasicName(item){//hyeco平台的设备列表，然后选择一个产品。你会得到四个字段basicName，loraProductKey，comMode，connectMode，你相应的置换创建基础型号里面对应的字段
                // console.log('e.selIteme.selItem',item)
                // this.formData.basicName = !this.formData.basicName?item.basicName+''
                this.formData.loraProductKey = item.loraProductKey+''
                this.formData.comMode = !this.formData.comMode?item.comMode*1:this.formData.comMode
                this.formData.connectMode = !this.formData.connectMode?item.connectMode*1:this.formData.connectMode
            },
            setSelectVal(e,key){
                 this.formData[key] = e.nameVal+''
                 
                //  if(key=='basicName'){//basicName，loraProductKey，comMode，connectMode
                //     this.formData.loraProductKey = e.selItem.loraProductKey
                //     this.formData.comMode = e.selItem.comMode
                //     this.formData.connectMode = e.selItem.connectMode
                //  }
            },
            setSelectValNew(e,key){
                // console.log('eeee',e)
                // console.log('keykeykey',key)
                let obj = {'customerId':'id',"pageId":"pageId","loraProductKey":"loraProductKey"}
              if(e){
                   this.formData[key] = e[obj[key]]+''
              }else{
                this.formData[key] = ''
              }
            },
            setThumbUrlthumb(item) {//图片上传
              console.log("url", item);
            //   let url = item.data+'_'+item.file.name
              let url = item.data
              this.photoArr = [...item.data]
              this.formData.imageId = this.photoArr.join(',');


            },
            removeThumbUrl(index){//删除图片
            //    this.photoArr.splice(index,1)
               this.photoArr  = []
               this.formData.imageId = this.photoArr.join(',');
            },
            designImplTypeSelect(e){
                // console.log('e',e)
                if(e.value==2){
                    this.formData.channelNumber=null
                    this.formData.smDeviceType=""
                }
            },
            showAdminData(url,params) {  //发布后的基础型号修改需要输入管理员密码
         
                this.adminModelBox.showModel = true

                this.adminModelBox.callbackFn = (password) => {//回调处理
                    //重新载入
                    
                    this.adminModelBox.loading = true;
                    this.axios.post(url, {...params,password:password}).then((result) => {
        
                        common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                            this.adminModelBox.loading = false;

                            this.$refs.verifyPwdRef.handleCancel()
                            setTimeout(() => {//滚动条问题
                                this.cancel();
                                this.fn()
                            }, 0);

                        },()=>{
                            this.disabled = false;
                            this.adminModelBox.loading = false;
                        })
                        
                        
                    }).catch((err) => {
                        this.disabled = false;
                        this.adminModelBox.loading = false;
                    });
                }
            },
            getMoreParams(params){
                console.log(params)
            },

            subData(name) {//提交表单
                if(!this.formData.comType){
                    this.comTypeRequired = true
                }
                // console.log('this.formData.comType',this.formData.comType)
                console.log('this.formData.pageId',this.formData)
                this.$refs[name].validate((valid) => {
                    console.log('valid',valid)
                    
                    if (valid) {
                        //  if(!this.formData.imageId){
                        //      common.msg('error',this.$t('productManage.validateAdd.photo'))
                        //      return false
                        //  }

                        if(!this.formData.comType){
                            return 
                        }
                        // console.log(111111,valid)
                        

                        
                        this.formData.joinSense = this.formData.joinSense1=='true'?true:false
                        let offlineOperation = this.formData.offlineOperation==1 ?true:false
                        let whetherShare = this.formData.whetherShare==1 ?true:false
                        let majorKeyId = !this.formData.majorKeyId || this.formData.majorKeyId=='undefined' ?null:this.formData.majorKeyId

                        let url = this.type == 2? this.config.urlArray.basicProductsSet:this.config.urlArray.basicProductsAdd
              
                        
                        let params = {...this.formData,offlineOperation,whetherShare,majorKeyId,dealerId:this.selectId}
                       
                        delete params.joinSense1
                        delete params.basicClassIdArr
                        
                        // hyecosmart这种的指令实现方式
                        // if(this.formData.communicateProtocol !=3 && formData.comMode!=4){
                        //     delete params.loraProductKey
                        // }
                        
                        // 实现类型是二进制klv
                        if(this.formData.designImplType ==2){

                            if(this.formData.connectMode ==6){//且connectMode是6 基站下设备
                                let obj = {'1':'A6k_t3Rng','5':'u_ElpqR7R','6':'HJTutqgnR'}
                                params.loraProductKey = obj[params.subdeviceType+'']
                            }else if(this.formData.connectMode ==5){//且connectMode是5 基站
                                params.loraProductKey = 'aYFrpqg7g'
                            }
                        }

                        console.log('loraProductKey',params.loraProductKey)

                        if(!((this.formData.designImplType ==2 && (this.formData.connectMode ==6 || this.formData.connectMode ==5)) || (this.formData.designImplType ==3))){
                            params.loraProductKey = ''
                        }

                       if(!((this.formData.connectMode ==6) || (this.formData.designImplType ==3 && this.formData.connectMode ==3))){
                            delete params.subdeviceType
                        }
                        

                        // if(!((this.formData.designImplType ==2 && this.formData.connectMode ==6) || (this.formData.designImplType ==3 && this.formData.connectMode ==3))){
                        //     delete params.subdeviceType
                        // }
                        
                        // // 没选communicateProtocol是1或者3  二进制klv或hyecosmart的json协议 ，loraProductKey置为空
                        // if(this.formData.communicateProtocol == 2 || this.formData.communicateProtocol ==4){
                        //     params.loraProductKey = ''
                        // }



                        // if(!(this.formData.communicateProtocol ==3 && this.formData.connectMode ==3)){
                        //     delete params.subdeviceType
                        // }

                        console.log('params',params)
                        // return

                        if(this.editFormData.published){
                            this.showAdminData(url,params)
                          
                            return
                        }

                        this.disabled = true;

                        // console.log('params',params)
 
                        this.axios.post(url, params).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.cancel();//重置表单
                                this.fn()
                            },()=>{
                                this.disabled = false;
                            })
                            
                            
                        }).catch((err) => {
                            // common.msg('error',this.$t('failed'),()=>{this.disabled = false;})
                            this.disabled = false;
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm();//重置表单
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                this.photoArr = []
                this.hasUpload = []
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.formData.basicClassIdArr = []
                this.productListFromHyeco = []
                this.formData.published = false
                this.formData.macQty = null
                this.formData.channelNumber=null
                this.comTypeText=""
                this.comTypeRequired = false
                // this.formData.modifyModelSync=false
                // this.formData.modifyDeviceSync=false
                this.formData.forbidden=false
                if(this.type == 2){
                    delete this.formData.id
                }
                
            }
        }
    }
</script>

<style lang='less' scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
.divinput{
    /deep/ .ivu-form-item-content{
        line-height: normal;
    }
}

/deep/ .ivu-input-number{
    width: 100% !important;
}
.ivu-input-div{
    cursor:pointer,

}

.verAddCon{
    position: relative;
    .title{
        font-size: 20px;
        padding: 4px 0 20px;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px
    }
    // .ivu-layout-content{
    //    min-width: 680px !important;
    //    overflow-x: scroll;
    // }
}
 /deep/ .ivu-form-item-content{
      margin-left: 176px !important;
      flex-grow: 1;
  }
.logoCon{
  /deep/ .ivu-form-item-content{
      margin-left: 0px !important;
  }
}
 /deep/ .ivu-form .ivu-form-item-label{
    width: 162px !important;
}

.editText{
    margin-left:8px;
    font-size:14px;
    color:#2d8cf0;
    cursor:pointer
}
</style>
